// Smooth fade-in al scroll
if ('IntersectionObserver' in window) {
  const sections = document.querySelectorAll('section');
  sections.forEach(s => { s.style.opacity = '0'; s.style.transform = 'translateY(20px)'; s.style.transition = 'opacity 600ms ease, transform 600ms ease'; });
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.transform = 'none'; io.unobserve(e.target); } });
  }, { threshold: 0.05 });
  sections.forEach(s => io.observe(s));
}

// Hero video rotator (estilo Graza)
(function heroRotator(){
  var stack = document.getElementById('heroStack');
  if (!stack) return;
  var videos = Array.prototype.slice.call(stack.querySelectorAll('video'));
  var dotsWrap = document.getElementById('heroDots');
  var pauseBtn = document.getElementById('heroPause');
  if (!videos.length) return;
  var idx = 0, paused = false;

  videos.forEach(function(v, i){
    var b = document.createElement('button');
    b.className = 'hero-video__dot' + (i === 0 ? ' is-active' : '');
    b.setAttribute('aria-label', 'Ver video ' + (i + 1));
    b.addEventListener('click', function(){ go(i); });
    dotsWrap.appendChild(b);
  });
  var dots = Array.prototype.slice.call(dotsWrap.children);

  function setActive(i){
    videos.forEach(function(v, j){ v.classList.toggle('is-active', j === i); });
    dots.forEach(function(d, j){ d.classList.toggle('is-active', j === i); });
  }
  function playCurrent(){
    var v = videos[idx];
    try { v.currentTime = 0; } catch(e){}
    var p = v.play();
    if (p && p.catch) { p.catch(function(){}); }
  }
  function next(){ go((idx + 1) % videos.length); }
  function go(i){
    if (i === idx) return;
    try { videos[idx].pause(); } catch(e){}
    idx = i;
    setActive(idx);
    if (!paused) playCurrent();
  }
  videos.forEach(function(v){
    v.addEventListener('ended', function(){ if (!paused) next(); });
    v.addEventListener('error', function(){ if (v.classList.contains('is-active') && !paused) next(); });
  });

  setActive(0);
  // El video parte cuando ya cargó el resto de la página, para no competir con las fotos.
  function start(){ if (!paused) playCurrent(); }
  if (document.readyState === 'complete') { start(); }
  else { window.addEventListener('load', start, { once: true }); }

  pauseBtn.addEventListener('click', function(){
    paused = !paused;
    if (paused) { try { videos[idx].pause(); } catch(e){} pauseBtn.textContent = '►'; pauseBtn.setAttribute('aria-label', 'Reanudar video'); }
    else { playCurrent(); pauseBtn.textContent = '❚❚'; pauseBtn.setAttribute('aria-label', 'Pausar video'); }
  });
})();
